export default __webpack_public_path__ + "static/media/debugger.8a05fe83.svg";